import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "General Ledger";
const description = `The General Ledger Report serves as the definitive, comprehensive record of all financial transactions within an organization, detailing every single debit and credit entry across all accounts. Organized chronologically, this fundamental report provides the complete history and supporting detail required for reconciling accounts, ensuring the accuracy of the Trial Balance, and ultimately acting as the centralized foundation for all major financial statements.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const GeneralLedger: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralLedger;
